<template>
  <el-row>
    <el-col :span="5">
      <basic-container style="overflow-x: auto; height: calc(100vh - 110px)">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <el-tree
          class="filter-tree"
          :props="treeProps"
          node-key="id"
          ref="leftTreeRef"
          :load="lazyLoadLeftTree"
          :filter-node-method="filterNode"
          lazy
          @node-click="nodeClick"
          v-loading="loading"
        >
        </el-tree>
      </basic-container>
    </el-col>
    <el-col :span="19">
      <basic-container>
        <el-form
          v-show="searchBoxFlag"
          ref="searchForm"
          :model="query"
          label-width="100px"
          margin-top="0"
          :rules="rules"
        >
          <el-col :span="8">
            <el-form-item label="车位编号:" prop="parkSpaceNo">
              <el-input v-model="query.parkSpaceNo" placeholder="车位编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车位状态:" prop="carParkStatus">
              <el-select v-model="query.carParkStatus" placeholder="全部" style="width: 100%">
                <el-option
                  v-for="item in carParkStatusList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                  style="padding-left: 10px"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="text-align: right">
            <!-- <el-form-item> -->
            <el-button type="primary" size="small" @click="submitSearchForm" icon="el-icon-search"
              >搜索
            </el-button>
            <el-button type="white" @click="searchReset" size="small" icon="el-icon-delete"
              >清空</el-button
            >
            <!-- </el-form-item> -->
          </el-col>
        </el-form>
        <avue-crud
          :option="carParkOption"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @row-save="rowSave"
          @row-del="rowDel"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @on-load="onLoad"
          @refresh-change="onLoad"
        >
          <template slot="menuRight">
            <searchFromShow
              :searchBoxFlag.sync="searchBoxFlag"
              :removeHeight="searchHeight"
              :option="option"
              style="float: right"
              :refOption="$refs.crud"
            ></searchFromShow>
          </template>
          <template slot="menuLeft">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="openNodeAddDialog">
              新增区域
            </el-button>
            <el-button type="success" icon="el-icon-edit" size="small" @click="openNodeEditDialog">
              修改区域
            </el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" @click="nodeDelete">
              删除区域
            </el-button>
            <!--            <el-button type="primary" icon="el-icon-plus" @click="openParkAddDialog">-->
            <!--              新增车位-->
            <!--            </el-button>-->
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              @click="handleDelete"
              v-show="handleDeleteListener"
            >
              删除车位
            </el-button>
          </template>

          <template slot="menu" slot-scope="scope">
            <el-button type="text" size="small" @click.native="openParkDetailDialog(scope.row)"
              >查看
            </el-button>
            <el-button type="text" size="small" @click.native="openParkEditDialog(scope.row)"
              >修改车位
            </el-button>
            <el-button
              type="text"
              size="small"
              style="color: #ff0000"
              @click.native="rowDel(scope.row)"
              >删除
            </el-button>
          </template>
        </avue-crud>

        <el-dialog
          :visible.sync="nodeAddShowDialogFlag"
          :modal-append-to-body="false"
          @opened="nodeAddDialogOpened"
          title="新增区域"
        >
          <div class="el-node-dialog-div">
            <avue-form
              ref="nodeAddFormRef"
              v-model="nodeAddForm"
              :option="nodeAddOption"
              @reset-change="nodeAddReset"
              @submit="nodeAddSubmit"
            >
              <template slot-scope="scope" slot="parentId">
                <el-select
                  :value="parentObjectName"
                  ref="nodeAddParentNodeSelectRef"
                  placeholder="请选择上级节点"
                  @clear="nodeAddClearParentNodeSelect"
                  @click.native="nodeAddClickParentNodeSelect"
                >
                  <el-option :value="parentObjectName" :label="parentObjectName">
                    <el-tree
                      ref="nodeAddParentNodeTreeRef"
                      node-key="id"
                      :props="treeProps"
                      :load="lazyLoadNodeAddParentNodeTree"
                      lazy
                      @node-click="nodeAddParentNodeTreeClick"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </template>
              <template slot="parentTypeName" slot-scope="scope">
                <el-input v-model="parentTypeName" readonly placeholder="请选择上级节点"></el-input>
              </template>
              <template slot="type" slot-scope="scope">
                <el-select v-model="nodeAddForm.type" placeholder="请选择">
                  <el-option style="padding-left: 10px" :key="2" :value="2" label="楼层">
                  </el-option>
                  <el-option style="padding-left: 10px" :key="3" :value="3" label="区域">
                  </el-option>
                </el-select>
              </template>
              <template slot="tempParkFlag" slot-scope="scope">
                <el-select v-model="nodeAddForm.tempParkFlag" clearable placeholder="请选择">
                  <el-option style="padding-left: 10px" value="0" label="是"></el-option>
                  <el-option style="padding-left: 10px" value="1" label="否"></el-option>
                </el-select>
              </template>
              <template slot="carParkStatus" slot-scope="scope">
                <el-select
                  v-model="nodeAddForm.carParkStatus"
                  placeholder="请选择状态"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in carParkStatusList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    style="padding-left: 10px"
                  >
                  </el-option>
                </el-select>
              </template>
              <template slot="carParkAreaType" slot-scope="scope">
                <el-select
                  v-model="nodeAddForm.carParkAreaType"
                  placeholder="请选择计费方式"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in carParkAreaFeeTypeList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    style="padding-left: 10px"
                  >
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitNodeAddDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>

        <el-dialog
          :visible.sync="nodeEditShowDialogFlag"
          :modal-append-to-body="false"
          @opened="nodeEditDialogOpened"
          title="修改区域"
        >
          <div class="el-node-dialog-div">
            <avue-form
              ref="nodeEditFormRef"
              v-model="nodeEditForm"
              :option="nodeEditOption"
              @reset-change="nodeEditReset"
              @submit="nodeEditSubmit"
            >
              <template slot="type" slot-scope="scope">
                <el-select v-model="nodeEditForm.type" placeholder="请选择">
                  <el-option style="padding-left: 10px" :key="2" :value="2" label="楼层">
                  </el-option>
                  <el-option style="padding-left: 10px" :key="3" :value="3" label="区域">
                  </el-option>
                </el-select>
              </template>
              <template slot="tempParkFlag" slot-scope="scope">
                <el-select v-model="nodeEditForm.tempParkFlag" clearable placeholder="请选择">
                  <el-option style="padding-left: 10px" value="0" label="是"></el-option>
                  <el-option style="padding-left: 10px" value="1" label="否"></el-option>
                </el-select>
              </template>
              <template slot="carParkStatus" slot-scope="scope">
                <el-select
                  v-model="nodeEditForm.carParkStatus"
                  placeholder="请选择状态"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in carParkStatusList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    style="padding-left: 10px"
                  >
                  </el-option>
                </el-select>
              </template>
              <template slot="carParkAreaType" slot-scope="scope">
                <el-select
                  v-model="nodeEditForm.carParkAreaType"
                  placeholder="请选择计费方式"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in carParkAreaFeeTypeList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    style="padding-left: 10px"
                  >
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitNodeEditDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>

        <el-dialog
          :visible.sync="parkAddShowDialogFlag"
          :modal-append-to-body="false"
          @opened="parkAddDialogOpened"
          title="新增车位"
        >
          <div class="el-park-dialog-div">
            <avue-form
              ref="parkAddFormRef"
              v-model="parkAddForm"
              :option="carParkAddOption"
              @reset-change="parkAddReset"
              @submit="parkAddSubmit"
            >
              <template slot-scope="scope" slot="parentId">
                <el-select
                  :value="parentObjectName"
                  ref="ParkAddParentNodeSelectRef"
                  placeholder="请选择上级节点"
                  clearable
                  @clear="ParkAddClearParentNodeSelect"
                  @click.native="parkAddClickParentNodeSelect"
                >
                  <el-option :value="parentObjectName" :label="parentObjectName">
                    <el-tree
                      ref="ParkAddParentNodeTreeRef"
                      node-key="id"
                      :props="treeProps"
                      :load="lazyLoadParkAddParentNodeTree"
                      lazy
                      @node-click="ParkAddParentNodeTreeClick"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </template>
              <template slot="carParkStatus" slot-scope="scope">
                <el-select
                  v-model="parkAddForm.carParkStatus"
                  placeholder="请选择状态"
                  style="width: 100%"
                  disabled
                >
                  <el-option
                    v-for="item in carParkStatusList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    style="padding-left: 10px"
                  >
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitParkAddDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>

        <el-dialog
          :visible.sync="parkEditShowDialogFlag"
          :modal-append-to-body="false"
          width="40%"
          @opened="parkEditDialogOpened"
          title="修改车位"
        >
          <div class="el-park-dialog-div">
            <avue-form
              ref="parkEditFormRef"
              v-model="parkEditForm"
              :option="carParkEditOption"
              @reset-change="parkEditReset"
              @submit="parkEditSubmit"
            >
              <template slot="parentName" slot-scope="scope">
                <el-input v-model="parkEditForm.parentName" disabled></el-input>
              </template>
              <template slot="parentParkTypeName" slot-scope="scope">
                <el-input v-model="parkEditForm.parentParkTypeName" disabled></el-input>
              </template>
              <template slot="parkSpaceNo" slot-scope="scope">
                <el-input v-model="parkEditForm.parkSpaceNo" placeholder="车位编码"></el-input>
              </template>
              <template slot="carParkStatus" slot-scope="scope">
                <el-select
                  v-model="parkEditForm.carParkStatus"
                  placeholder="请选择状态"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in carParkStatusList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    style="padding-left: 10px"
                  >
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitParkEditDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="rowParkDetailShowDialogFlag"
          :modal-append-to-body="false"
          @opened="parkEditDialogOpened"
          title="查看车位"
        >
          <div class="el-park-dialog-div">
            <avue-form
              ref="parkDetailFormRef"
              v-model="parkDetailForm"
              :option="carParkDetailOption"
              @reset-change="parkEditReset"
            >
              <template slot="parentName" slot-scope="scope">
                <el-input v-model="parkDetailForm.parentName" disabled></el-input>
              </template>
              <template slot="parentParkTypeName" slot-scope="scope">
                <el-input v-model="parkDetailForm.parentParkTypeName" disabled></el-input>
              </template>
              <template slot="parkSpaceNo" slot-scope="scope">
                <el-input
                  v-model="parkDetailForm.parkSpaceNo"
                  placeholder="车位编码"
                  disabled
                ></el-input>
              </template>
              <template slot="carParkStatus" slot-scope="scope">
                <el-select
                  v-model="parkDetailForm.carParkStatus"
                  placeholder="请选择状态"
                  style="width: 100%"
                  disabled
                >
                  <el-option
                    v-for="item in carParkStatusList"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                    style="padding-left: 10px"
                  >
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope" slot="menuForm">
                <el-button @click="quitParkViewDialog">退出</el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import {
  getTreeChildrenCarParkNode,
  getList,
  addParkSpaceNode,
  getDetailById,
  update,
  updateCarSpace,
  addPark,
  remove,
  syncParkPositions,
} from '@/api/v4ward/carv2/carpark';
import { mapGetters } from 'vuex';
import treeOption from './tree-option';
import carParkAddOption from './carpark-add-option';
import carParkOption from './carpark-option';
import carParkDetailOption from './carpark-detail-option';
import carParkEditOption from './carpark-edit-option';
import nodeAddOption from './node-add-option';
import nodeEditOption from './node-edit-option';
import { getDictionary } from '../../../../api/common';
import { getDictionaryWithIntKey } from '../../../../api/common';
import searchFromShow from '@/components/search-form-show/index';
export default {
  components: { searchFromShow },
  data() {
    return {
      searchBoxFlag: true,
      handleDeleteListener: false, //当状态值为空闲时显示该批量删除按钮
      parentTypeName: '', //上级属性名称
      editNodeParentTypeName: '', //修改节点上级属性名称
      editNodeParentParkName: '',
      parkTypeList: {},
      carParkStatusList: {},
      carParkAreaFeeTypeList: {},
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        parkType: 'parkType',
        //本节点类型名
        parkTypeName: 'parkTypeName',
      },
      leftTreeRoot: {},
      leftTreeResolve: {},

      isNodeAddDialogFirstOpen: true,
      nodeAddParentNodeTreeRoot: {},
      nodeAddParentNodeTreeResolve: {},
      isParkAddDialogFirstOpen: true,
      ParkAddParentNodeTreeRoot: {},
      ParkAddParentNodeTreeResolve: {},

      //选中的树形节点信息
      treeTrackId: '',
      filterText: '',

      //选中的表格行信息
      tableTrackId: '',

      //父节点树结构相关信息
      parentId: '',
      parentObjectName: '',
      parentParkTypeName: '',

      //窗口显示开关
      nodeAddShowDialogFlag: false,
      nodeEditShowDialogFlag: false,
      parkAddShowDialogFlag: false,
      //parkViewShowDialogFlag: false,
      parkEditShowDialogFlag: false,
      rowParkDetailShowDialogFlag: false,

      //form表单数据
      form: {},
      nodeAddForm: {},
      nodeEditForm: {},
      parkAddForm: {},
      parkEditForm: {},
      parkDetailForm: {},

      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],

      treeOption: treeOption,
      nodeAddOption: nodeAddOption,
      nodeEditOption: nodeEditOption,
      carParkOption: carParkOption,
      carParkAddOption: carParkAddOption,
      carParkEditOption: carParkEditOption,
      carParkDetailOption: carParkDetailOption,

      //页面数据
      treeData: [],
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basePark_add, false),
        viewBtn: this.vaildData(this.permission.basePark_view, false),
        delBtn: this.vaildData(this.permission.basePark_delete, false),
        editBtn: this.vaildData(this.permission.basePark_edit, false),
        syncBtn: this.vaildData(this.permission.basePark_sync, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[2].$el.addEventListener('click', () => {
          if (this.carParkOption.height == this.bodyHeight - 350) {
            this.carParkOption.height = this.bodyHeight - 290;
          } else {
            this.carParkOption.height = this.bodyHeight - 350;
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
    this.carParkOption.height = this.bodyHeight - 350;
    this.initParkTypeList();
    this.initCarParkStatusList();
    this.initCarParkAreaFeeTypeList();
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.leftTreeRef.filter(val);
    },
    'nodeAddForm.type'() {
      const blockLocalNoColumn = this.findObject(this.nodeAddOption.column, 'blockLocalNo');
      if (this.vdui.isNotEmpty(this.nodeAddForm.type)) {
        if (this.nodeAddForm.type == 3) {
          blockLocalNoColumn.disabled = false;
        } else {
          this.nodeAddForm.blockLocalNo = '';
          blockLocalNoColumn.disabled = true;
        }
      } else {
        blockLocalNoColumn.disabled = true;
      }
    },
  },
  methods: {
    handleSync() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定下发所选车位信息到对应车场终端?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return syncParkPositions({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    initParkTypeList: function () {
      getDictionary('park_type').then((data) => {
        this.parkTypeList = data.data;
      });
    },
    initCarParkStatusList: function () {
      getDictionaryWithIntKey('car_park_status').then((data) => {
        this.carParkStatusList = data.data;
      });
    },
    initCarParkAreaFeeTypeList: function () {
      getDictionaryWithIntKey('park_area_fee_type').then((data) => {
        this.carParkAreaFeeTypeList = data.data;
      });
    },
    //懒加载树结构
    lazyLoadLeftTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.leftTreeRoot = node;
        this.leftTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenCarParkNode({ id: id }).then(({ data }) => {
        let newData = [];
        data.forEach((ele) => {
          if (ele.parkType != 4) {
            newData.push(ele);
          }
        });
        resolve(newData);
      });
    },
    lazyLoadNodeAddParentNodeTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.nodeAddParentNodeTreeRoot = node;
        this.nodeAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenCarParkNode({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    lazyLoadParkAddParentNodeTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        this.ParkAddParentNodeTreeRoot = node;
        this.ParkAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenCarParkNode({ id: id }).then(({ data }) => {
        resolve(data);
      });
    },
    //重新加载左侧树结构
    reloadLeftTree() {
      this.leftTreeRoot.childNodes = [];
      this.lazyLoadLeftTree(this.leftTreeRoot, this.leftTreeResolve);
    },
    reloadNodeAddParentNodeTree() {
      this.nodeAddParentNodeTreeRoot.childNodes = [];
      this.lazyLoadNodeAddParentNodeTree(
        this.nodeAddParentNodeTreeRoot,
        this.nodeAddParentNodeTreeResolve
      );
    },
    reloadParkAddParentNodeTree() {
      this.ParkAddParentNodeTreeRoot.childNodes = [];
      this.lazyLoadParkAddParentNodeTree(
        this.ParkAddParentNodeTreeRoot,
        this.ParkAddParentNodeTreeResolve
      );
    },
    //树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data[this.treeProps.label].indexOf(value) !== -1;
    },

    //点击左侧树结构回调
    nodeClick(data) {
      this.treeTrackId = data.id;
      this.page.currentPage = 1;
      this.query = {};
      this.onLoad();
    },

    //打开窗口
    openNodeAddDialog() {
      this.nodeAddShowDialogFlag = true;
    },
    openNodeEditDialog() {
      if (this.treeTrackId) {
        let node = this.$refs.leftTreeRef.getNode(this.treeTrackId);
        if (node.data[this.treeProps.parkType] === 4) {
          this.$message.error('请不要编辑停车位的节点信息!');
          return;
        } else if (node.data[this.treeProps.parkType] === 1) {
          this.$message.error('请不要编辑停车场的节点信息!');
          return;
        } else {
          this.nodeEditShowDialogFlag = true;
        }
        this.editNodeParentTypeName = node.parent.data.parkTypeName;
        this.editNodeParentParkName = node.parent.data.title;
      } else {
        this.$message.error('请在左侧树形列表中选择节点!');
        return;
      }
    },
    openParkAddDialog() {
      this.parkAddShowDialogFlag = true;
    },
    openParkEditDialog(row) {
      this.tableTrackId = row.id;
      this.parkEditShowDialogFlag = true;
      this.parkEditForm.id = row.id;
      this.parkEditForm.parentId = row.parentId;
      this.parkEditForm.parkSpaceNo = row.parkSpaceNo;
      this.parkEditForm.carParkStatus = row.carParkStatus;
      this.parkEditForm.parentName = row.parentName;
      this.parkEditForm.parentParkTypeName = row.spaceCategoryName;
      this.parkEditForm.type = row.type;
    },
    openParkDetailDialog(row) {
      this.rowParkDetailShowDialogFlag = true;
      this.parkDetailForm.parkSpaceNo = row.parkSpaceNo;
      this.parkDetailForm.carParkStatus = row.carParkStatus;
      this.parkDetailForm.parentName = row.parentName;
      this.parkDetailForm.parentParkTypeName = row.spaceCategoryName;
    },

    //窗口打开完成回调函数
    nodeAddDialogOpened() {
      this.$refs.nodeAddFormRef.resetForm();
      this.parentId = '';
      this.parentObjectName = '';
      this.parentParkTypeName = '';
    },
    nodeEditDialogOpened() {
      this.$refs.nodeEditFormRef.resetForm();

      getDetailById({ id: this.treeTrackId }).then(({ data }) => {
        this.nodeEditForm = data;
        this.nodeEditForm.parentParkName = this.editNodeParentParkName;
        this.nodeEditForm.parentTypeName = this.editNodeParentTypeName;
      });
    },
    parkAddDialogOpened() {
      this.$refs.parkAddFormRef.resetForm();

      this.parentId = '';
      this.parentObjectName = '';
      this.parentParkTypeName = '';
      this.parkAddForm.carParkStatus = 0;
      this.parkAddForm.parkTypeName = '车位';
    },
    parkEditDialogOpened() {},

    // 初始化父节点树结构
    initNodeAddParentNodeTree() {
      this.initSelectTreeStyle();
      if (!this.isNodeAddDialogFirstOpen) {
        this.reloadNodeAddParentNodeTree();
      } else {
        this.isNodeAddDialogFirstOpen = false;
      }
    },
    initParkAddParentNodeTree() {
      this.initSelectTreeStyle();
      if (!this.isParkAddDialogFirstOpen) {
        this.reloadParkAddParentNodeTree();
      } else {
        this.isParkAddDialogFirstOpen = false;
      }
    },
    initSelectTreeStyle() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0];
        let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar');
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;';
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },

    //点击窗口中的父节点选择框回调函数
    nodeAddClickParentNodeSelect() {},
    parkAddClickParentNodeSelect(node) {},
    // 窗口中父节点树节点点击回调
    nodeAddParentNodeTreeClick(node) {
      if (node.parkType === 4) {
        this.$message.error('不允许将停车位作为上级');
        return false;
      }
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];

      this.parentObjectName = nodeTitle;
      this.parentTypeName = node.parkTypeName;

      if (this.nodeAddShowDialogFlag) {
        this.$refs.nodeAddParentNodeSelectRef.blur();
        this.nodeAddForm.parentId = nodeId;
      }
    },
    parkTypeToParkTypeName(parkType) {
      var parkTypeName = '';
      this.parkTypeList.forEach(function (value, index, array) {
        if (value.dictKey == parkType) {
          parkTypeName = value.dictValue;
          return;
        }
      });
      return parkTypeName;
    },
    ParkAddParentNodeTreeClick(node) {
      console.log(node);
      if (node.parkType == 1) {
        this.$message.error('请不要将停车场作为上级节点!');
        return;
      }
      if (node.parkType == 4) {
        this.$message.error('请不要将停车位作为上级节点!');
        return;
      }
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.parkTypeName];

      this.parentObjectName = nodeTitle;

      if (this.parkAddShowDialogFlag) {
        this.$refs.ParkAddParentNodeSelectRef.blur();
        this.parkAddForm.parentId = nodeId;
        this.parkAddForm.parentParkTypeName = nodeTypeName;
      }
    },

    //重置窗口数据
    nodeAddReset() {
      this.initNodeAddParentNodeTree();
      this.nodeAddClearParentNodeSelect();
      this.nodeAddForm.carParkAreaType = this.carParkAreaFeeTypeList[0].dictKey;
    },
    nodeEditReset() {
      this.nodeEditForm.id = this.treeTrackId;
      this.nodeEditForm.parentId = this.parentId;
      this.nodeEditForm.parentObjectName = this.parentObjectName;
      this.nodeEditForm.parentParkTypeName = this.parentParkTypeName;
    },
    parkAddReset() {
      this.initParkAddParentNodeTree();
    },
    parkEditReset() {
      this.parkEditForm.id = this.tableTrackId;
      this.parkEditForm.parentId = this.parentId;
    },

    // 清除父节点树选项
    nodeAddClearParentNodeSelect() {
      this.parentObjectName = '';
      this.clearTreeStyle(this.nodeAddShowDialogFlag, 'nodeAddParentNodeTree');
      this.$emit('getValue', null);
    },
    ParkAddClearParentNodeSelect() {
      this.parentObjectName = '';
      this.parkAddForm.parentParkTypeName = '';
      this.clearTreeStyle(this.parkAddShowDialogFlag, 'ParkAddParentNodeTree');
      this.$emit('getValue', null);
    },
    clearTreeStyle(showDialogFlag, treeId) {
      if (showDialogFlag) {
        let allNode = document.querySelectorAll('#' + treeId + ' .el-tree-node');
        allNode.forEach((element) => element.classList.remove('is-current'));
      }
    },

    nodeAddSubmit(form, done) {
      this.$refs.nodeAddFormRef.validate((valid) => {
        if (valid) {
          form.parkId = this.nodeAddForm.parkId;
          console.log('新增区域提交：' + JSON.stringify(form));
          addParkSpaceNode(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();

              this.$message.success('操作成功!');
              this.parentTypeName = '';
              this.nodeAddShowDialogFlag = false;
              this.$refs.nodeAddFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    nodeEditSubmit(form, done) {
      this.$refs.nodeEditFormRef.validate((valid) => {
        if (valid) {
          console.log(form);
          update(form).then(
            () => {
              this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.nodeEditShowDialogFlag = false;

              this.$refs.nodeEditFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    parkAddSubmit(form, done) {
      this.$refs.parkAddFormRef.validate((valid) => {
        if (valid) {
          addPark(form).then(
            () => {
              // this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.parkAddShowDialogFlag = false;

              this.$refs.parkAddFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    parkEditSubmit(form, done) {
      this.$refs.parkEditFormRef.validate((valid) => {
        if (valid) {
          console.log(form);
          updateCarSpace(form).then(
            () => {
              // this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.parkEditShowDialogFlag = false;

              this.$refs.parkEditFormRef.resetForm();
              done();
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
    },
    quitNodeAddDialog() {
      this.nodeAddShowDialogFlag = false;
      this.$refs.nodeAddFormRef.resetForm();
    },
    quitNodeEditDialog() {
      this.nodeEditShowDialogFlag = false;
      this.$refs.nodeEditFormRef.resetForm();
    },
    quitParkAddDialog() {
      this.parkAddShowDialogFlag = false;
      this.$refs.parkAddFormRef.resetForm();
    },
    quitParkEditDialog() {
      this.parkEditShowDialogFlag = false;
      this.$refs.parkEditFormRef.resetForm();
    },
    quitParkViewDialog() {
      this.rowParkDetailShowDialogFlag = false;
      this.$refs.parkViewFormRef.resetForm();
    },

    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log(row.carParkStatus);
          if (row.carParkStatus != 0) {
            throw '该车位状态不允许删除';
          }
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        })
        .catch((reason) => {
          console.log(reason);
          //this.$message.error(reason);
        });
    },
    nodeDelete() {
      if (this.treeTrackId) {
        let node = this.$refs.leftTreeRef.getNode(this.treeTrackId);
        if (node.data[this.treeProps.parkType] === 1) {
          this.$message.error('请不要删除停车场');
          return;
        } else {
          let ids = [];
          ids.push(this.treeTrackId);
          console.log(ids);
          this.$confirm('确定将该节点删除?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return remove({ ids: ids.join(',') });
            })
            .then(() => {
              this.reloadLeftTree();
              this.onLoad();
              this.$message.success('操作成功!');
              this.$refs.crud.toggleSelection();
            });
        }
      } else {
        this.$message.error('请在左侧树形列表中选择节点!');
        return;
      }
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    submitSearchForm() {
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize, parentId: this.treeTrackId },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
        if (this.query.carParkStatus == 0) this.handleDeleteListener = true;
        else this.handleDeleteListener = false;
      });
    },
  },
};
</script>

<style>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}

.el-select-dropdown__item.selected {
  font-weight: normal;
}

ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}

.el-tree-node__label {
  font-weight: normal;
}

.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}

.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 400px;
  overflow: auto;
}

.el-park-dialog-div {
  overflow: auto;
}
</style>
